import styled from "styled-components";

export const DotsDropdownWrapper = styled.div`
  display: flex;
  max-width: 250px;
  flex-direction: column;
  padding: 15px 20px;
  position: absolute;
  background: ${(props) => props.theme.bgColor};
  box-shadow: 3px 8px 9px rgba(0, 0, 0, 0.25);
  border-radius: 16px;
  z-index: 2;
  bottom: 85px;
  right: 10px;
`;

export const DotsDropdownRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 7px 0;
`;

export const DotsLogo = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
`;

export const DotsInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  overflow: hidden;
  & span {
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
  }
  & a {
    font-family: "Inter";
    font-style: normal;
    font-weight: 200;
    font-size: 13px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
